import React from 'react';
import _ from 'underscore';
import {I18nextProvider} from 'react-i18next';
import AppContext from 'components/appContext';
import userService from 'services/userService';
import languageService from 'services/languageService';
import {i18nInit} from 'root/internationalization/config';

const delta = 51;
const headerHeight = 50;
const withAppStore = (Component) => {
    return class extends React.Component {
        constructor(props) {
            super(props);
    
            this.state = {
                hideHeader: false,
                lastScrollTop: 0,
                appMap: null,
                userDetails: {},
                currentScene: null,
                currentModule: null,
                drawerOpen: false,
                isInitialized: false,
                showCurrentPortalInfo: false,
            }
        }

        componentDidMount(){
            languageService.init()
        }

        _updateScrollValue(value){
            _.throttle(this._hasScrolled(value), 250);
        }
    
        _hasScrolled(st) {
            if(Math.abs(this.state.lastScrollTop - st) <= delta)
                return;
    
            if (st > this.state.lastScrollTop && st > headerHeight){
                this.setState({
                    hideHeader: true,
                })
            } else {
                this.setState({
                    hideHeader: false,
                })
            }
    
            this.setState({
                lastScrollTop: st
            })
        }
    
        _registerModule(code, map){
            this.setState({
                appMap: {
                    ...this.state.appMap,
                    [code] : map
                }
            });
        }

        _getSelectedRole(details) {
            //details.ROLES is a string that could contain multiple roles like 'SUPERVISOR,TRAINEE'
            const roles = details.ROLES ? details.ROLES.split(',') : []; // Split the string or assign an empty array if it's empty
            const selectedRole = roles.length === 0 ? "" : (roles.includes('TRAINEE') ? 'TRAINEE' : roles[0]); // Check if the array is empty, if not select 'TRAINEE' or the first role                        

            return selectedRole;
        }
    
        _setUserDetails(details){
            if (details.hasOwnProperty('ROLES')) {
                details.ROLES = details.ROLES.toUpperCase();
            }
            
            if(!details.hasOwnProperty('CURRENT_ROLE')){
                details.CURRENT_ROLE = this._getSelectedRole(details);
            }
    
            this.setState({
                userDetails: {
                    ...this.state.userDetails,
                    ...details
                }
            });
            userService.setUserRole(details.CURRENT_ROLE);
        }
    
        _setCurrentScene(pageName){
            this.setState({
                currentScene: pageName,
            });
        }
    
        _setCurrentModule(currentModule){
            this.setState({
                currentModule: currentModule,
            });
        }
    
        _clearAppContext() {
            userService.setUserRole(null);
            this.setState({
                userDetails: {},
                currentScene: null,
                drawerOpen : false,
            });
            // remove all popovers
            let popovers = document.getElementsByClassName('popover');
    
            while (popovers[0]) {
                popovers[0].parentNode.removeChild(popovers[0]);
            }
        }

        _set(prop, val) {
            this.setState({
                [prop] : val,
            });
        }

        render() {
            return (
                <I18nextProvider i18n={i18nInit}>
                    <AppContext.Provider
                        value={{
                            hideHeader: this.state.hideHeader,
                            updateScrollValue: this._updateScrollValue.bind(this),
                            registerModule: this._registerModule.bind(this),
                            appMap: this.state.appMap,
                            userDetails: this.state.userDetails,
                            setCurrentScene: this._setCurrentScene.bind(this),
                            currentScene: this.state.currentScene,
                            setUserDetails: this._setUserDetails.bind(this),
                            setCurrentModule : this._setCurrentModule.bind(this),
                            currentModule : this.state.currentModule,
                            clearAppContext: this._clearAppContext.bind(this),
                            drawerOpen : this.state.drawerOpen,
                            showCurrentPortalInfo : this.state.showCurrentPortalInfo,
                            set : this._set.bind(this),
                        }}
                    >   
                        <Component
                            {...this.props}
                        />
                    </AppContext.Provider>
                </I18nextProvider>
            )
        }
    }
}
export default withAppStore;